import React from 'react';

export default function btlogo(props) {
    var fill = props.fill;
    return (
        <svg {...props} viewBox="0 0 1920 630.66">
            <path d="M130.117,506.609V124.046h454.644c214.565,0,238.965,9.981,238.965,83.163c0,63.759-26.614,83.723-172.434,83.723h-36.591v26.618h36.591c153.581,0,178.529,21.062,178.529,86.491c0,90.926-44.911,102.568-251.162,102.568H130.117L130.117,506.609z M379.059,277.627H506.58c54.335,0,60.99-10.536,60.99-49.9c0-31.602-10.536-39.918-60.99-39.918H379.059V277.627z M379.059,441.186H506.58c59.328,0,69.311-12.202,69.311-53.232c0-37.698-7.762-51.557-70.418-51.557H379.059V441.186z M1092.631,506.609V203.887H871.405v-79.841h705.796v79.836h-221.766v302.723h-262.805V506.609z" />
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/btdk.js
 **/